import { render, staticRenderFns } from "./electric-bill-info.vue?vue&type=template&id=f873bb42&scoped=true&"
import script from "./electric-bill-info.vue?vue&type=script&lang=js&"
export * from "./electric-bill-info.vue?vue&type=script&lang=js&"
import style0 from "./electric-bill-info.vue?vue&type=style&index=0&id=f873bb42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f873bb42",
  null
  
)

export default component.exports